import React from 'react';
import DocAttributeRow from './DocAttributeRow';
import withView from '../../cmn/docAutomation/withView';
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle';
import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../library/layout/Index";
import useDeviceDetection from '../../../library/hooks/deviceIntegration/useDeviceDetection';

const DocAttribute = (props) => {
    const { formObject, viewData, ...restProps } = props;

    const deviceInfo = useDeviceDetection();

    const renderHeading = () => {
        if(!showInPopup)
        {
            return(
                <UiViewHeading>
                    <UiTitle>
                        <FormTitle formObject={formObject} value="" />
                    </UiTitle>
                </UiViewHeading>
            )
        }
    }

    const renderConfigBtn = () => {
        if (Object.keys(viewData).length === 0)
            return (
                <div className="uiConfigureAction" >
                </div>
            )
    }

    if (!viewData)
        return (null);

    const showInPopup = formObject.dataList.showInPopup === "1" ? true : false;
    
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={showInPopup} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '450px' }}
            formStyle={{ width: '350px' }} formTitle={<FormTitle formObject={formObject} value="Document Attribute" />}
        >
            <UiView>
                {
                    renderHeading()
                }
                <UiViewContent>
                    {
                        renderConfigBtn()
                    }
                    <div className='uiSecContents'>
                            <ul className='uiListTable uiListAttribute'>
                                {
                                    Object.values(viewData).map((row, index) => (
                                        <DocAttributeRow key={index} deviceInfo={deviceInfo} formObject={formObject} rowKey={row.rowKey} viewData={row} />
                                    ))
                                }
                            </ul>
                    </div>
                </UiViewContent>
            </UiView >
        </FormDialog>
    )
}

export default withView(DocAttribute, "docAttributeValue", "")
